// extracted by mini-css-extract-plugin
export default {"breakpoint-tablet":"928px","container-large-width":"1152px"};